import { tv } from '~/utils/tv'

export const inputTextClearButtonContainerVariants = tv({
  base: 'input-text-clear-button invisible hidden',
  variants: {
    size: {
      md: '-mr-[6px]',
      ml: '-mr-[8px]',
      lg: '-mr-[8px]',
      xl: '-mr-[8px]',
    },
    readOnly: { true: '' },
    disabled: { true: '' },
    isActive: { true: '' },
  },
  compoundVariants: [
    {
      readOnly: false,
      disabled: false,
      isActive: true,
      class:
        'peer-focus/field:peer-[:not(:placeholder-shown)]/field:visible peer-focus/field:peer-[:not(:placeholder-shown)]/field:flex group-hover:peer-[:not(:placeholder-shown)]/field:flex',
    },
  ],
  defaultVariants: {
    readOnly: false,
    disabled: false,
  },
})

export const inputTextClearButtonVariants = tv({
  base: '!px-none',
  variants: {
    size: {
      md: '!h-medium !w-medium',
      ml: '!h-mediumlarge !min-w-mediumlarge',
      lg: '!h-mediumlarge !min-w-mediumlarge',
      xl: '!h-mediumlarge !min-w-mediumlarge',
    },
  },
})
